
import React from 'react'
import Nav from '../Nav/Nav'
import Hero from '../Home/Hero'
import Footer from '../Footer/Footer'
import NotfoundHero from './NotFoundHero'

const Notfound = () => {
  return (
    <>
    <Nav />
    <NotfoundHero />
    <section className='py-24 flex flex-col justify-center items-center'>
        <h2 className='text-[#1C1F35] font-semibold text-9xl text-center'>
            4<span className='text-[#5146AE]'>0</span>4
        </h2>
        <h2 className='text-4xl font-semibold text-[#1C1F35] text-center mt-6'>
        Oops! Page not found.
        </h2>
        <p className='text-base font-medium text-[#666C89] mt-3 text-center'>
        Let’s get you to where you need to be.
        </p>
        <button className='bg-[#5146AE] rounded-md mt-5 text-white w-[159px] h-[56px] font-medium text-base'>Back to Home </button>
    </section>
    <Footer />
    </>
  )
}

export default Notfound